import React from "react";

class PointsRedemption extends React.Component {
  constructor(props){
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
  }
  onSubmit(e) {
    e.preventDefault();
    this.props.changeView('offer_incentives');
  }
  render() {
    return (
      <div className="main-container-loyalty">
        <h3 className="base-heading">SET YOUR LOYALTY PROGRAM</h3>
        <p className="sub-heading">
          Choose how your customers will redeem their points
        </p>
        <div className="loyalty-menu-options-child">
          <img
            className="loyalty-menu-options-child-image"
            src="/amountSpent.svg"
          />
          <p className="loyalty-menu-heading">Earn points by Amount</p>
        </div>

        <div className="loyalty-menu-form">
          <form onSubmit={this.onSubmit}>
            <div className="loyalty-menu-form-field">
              <p>For redemption, how much is each points worth</p>
              <div className="loyalty-menu-form-custom-div">
                Rs.
                <input
                  type="number"
                  className="loyalty-form-input-field"
                  placeholder="0"
                />
              </div>
            </div>

            <div className="loyalty-menu-form-field">
              <p>Maximum number of points that can be redeemed per transaction</p>
              <div className="loyalty-menu-form-custom-div">
                Rs.
                <input
                  type="number"
                  className="loyalty-form-input-field"
                  placeholder="0"
                />
              </div>
            </div>

            <div className="loyalty-menu-form-button-container">
              <button type="submit" className="loyalty-menu-form-button">
                Next
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default PointsRedemption;



// WEBPACK FOOTER //
// ./src/containers/LoyaltySetup/PointsRedemption.js